const ja = {
  warning: {
    start1: "引き出しへの影響を避けるため、認証情報の有効期限が近づいています。",
    start2: "認証情報の有効期限が切れたため、一時的に退会機能が利用できなくなりました。",
    middle: "ここをクリック",
    end: "更新情報へ進みます。"
  },
  alertInfo: {
    submit: "更新する",
    title: "あなたの認定情報",
    status1: "期限切れ",
    status2: "もうすぐ期限切れになります",
    label: "あなたが登録した",
    label1: "法人",
    label2: "株主",
    label2_1: "監督",
    label3: "受益者",
    label4: "会社",
    label5: "身分証明情報",
    label6: "出金への影響を避けるため、できるだけ早く証明書情報を更新してください。",
    label7: "一時的に出金機能が利用できなくなりますので、速やかにIDを更新してください。資料が更新され承認されたら、出金サービスを再開します。ご協力ありがとうございます。"
  }
};
export default ja;